export const policyDescription = 'Password must be at least 8 characters';
